module.exports = __webpack_public_path__ + "img/successfailure-expired.8aa25c77.svg";